import { render, staticRenderFns } from "./UpdateHolidayDialog.vue?vue&type=template&id=897253ee&scoped=true"
import script from "./UpdateHolidayDialog.ts?vue&type=script&lang=ts&external"
export * from "./UpdateHolidayDialog.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "897253ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('897253ee')) {
      api.createRecord('897253ee', component.options)
    } else {
      api.reload('897253ee', component.options)
    }
    module.hot.accept("./UpdateHolidayDialog.vue?vue&type=template&id=897253ee&scoped=true", function () {
      api.rerender('897253ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Holidays/components/UpdateHolidayDialog/UpdateHolidayDialog.vue"
export default component.exports